import React from 'react';
import PropTypes, { bool, oneOfType, string } from 'prop-types';
import classNames from 'classnames';
import { Col } from '@thd-olt-component-react/core-ui';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import { MAP_TOOLTIP_CONTENT } from '../../constants';
import { useOrderAPackageContext } from '../../../OrderAPackageContext';

import './totalPricing.scss';

export const TotalAmount = ({
  value,
  mapExistsInPackage,
  resize,
  basic,
  noTooltip,
  noPadding,
  title,
  hideTotalAmount,
  haveAuthMapPolicy
}) => {
  const { channel } = useOrderAPackageContext();
  const isSubtotal = title === 'Subtotal' ? '__subtotal' : '';
  const valueTitleClasses = classNames(`total-value${isSubtotal}__title`, {
    'total-value__title--basic': basic,
  });
  const valueCurrencyClasses = classNames(`total-value${isSubtotal}__currency`, {
    'total-value__currency--resize': resize
  });
  const valueDollarClasses = classNames(`total-value${isSubtotal}__dollars`, {
    'total-value__dollars--resize': resize,
  });
  const valueCentsClasses = classNames(`total-value${isSubtotal}__cents`, {
    'total-value__cents--resize': resize,
  });
  const testId = title?.replace(/ /g, '-') || 'Total-Amount';

  const shouldDisplayTotal = !hideTotalAmount || haveAuthMapPolicy;
  const shouldRenderStrikethrough = mapExistsInPackage && !haveAuthMapPolicy;

  const renderTotalValue = () => (
    basic ? (
      <div className="total-value--basic u__bold">
        {`${value?.dollars}.${value?.cents}`}
        {shouldRenderStrikethrough && <span className="strikethrough" />}
      </div>
    ) : (
      <div className="total-value u__bold">
        <span className={valueCurrencyClasses}>$</span>
        <span className={valueDollarClasses}>{value?.dollars}</span>
        <span className={valueCentsClasses}>{value?.cents}</span>
        {shouldRenderStrikethrough && <span className="strikethrough" />}
      </div>
    )
  );

  return (
    <div className="total-price" data-testid={testId}>
      {value && (
        <Col className="total-container u__bold" nopadding={noPadding}>
          {title && <span className={valueTitleClasses}>{title}</span>}
          <div>
            {shouldDisplayTotal && renderTotalValue()}
            {mapExistsInPackage && !noTooltip && (
              <>
                {!haveAuthMapPolicy && (
                  <Tooltip
                    channel={channel}
                    closeButton
                    content={MAP_TOOLTIP_CONTENT}
                    maxWidth={300}
                    placement="bottom"
                  >
                    <div style={{ color: '#3E7697', cursor: 'pointer' }} id="summary-total">
                      See Lower Price In Cart
                    </div>
                  </Tooltip>
                )}
              </>
            )}
          </div>
        </Col>
      )}
    </div>
  );
};

TotalAmount.propTypes = {
  value: oneOfType([PropTypes.object, string]),
  mapExistsInPackage: bool,
  title: string,
  resize: bool,
  basic: bool,
  noTooltip: bool,
  noPadding: bool,
  hideTotalAmount: bool,
  haveAuthMapPolicy: bool
};

TotalAmount.defaultProps = {
  value: null,
  mapExistsInPackage: false,
  title: '',
  resize: false,
  basic: false,
  noPadding: false,
  noTooltip: false,
  hideTotalAmount: false,
  haveAuthMapPolicy: false
};

TotalAmount.displayName = 'TotalAmount';